import FeedbackPage from '@/components/FeedbackPage'

export default function HabitsFeedbackPage() {
  return (
    <FeedbackPage emoji="🧐" title="pages.onboarding.habitsFeedback.title" />
  )
}
